import { CreateControllerFn } from '@wix/yoshi-flow-editor';
import {
  createMembersAreaWidgetPluginService,
  createWidgetPluginExports,
} from '@wix/members-area-widget-plugin-lib/viewer';
import {
  getNotifications,
  getUnseenCount,
  markAllAsRead,
  markAsRead,
} from '../../apis/members-feed/members-feed';

const createController: CreateControllerFn = async ({
  flowAPI,
  controllerConfig,
}) => {
  const widgetPluginService = createMembersAreaWidgetPluginService();

  const initialize = async () => {
    const [notificationsRes, unseenCount] = await Promise.all([
      getNotifications(flowAPI),
      getUnseenCount(flowAPI),
    ]);

    controllerConfig.setProps({
      notificationsRes,
      unseenCount,
      markAllAsRead: () => markAllAsRead(flowAPI),
      markAsRead: (id: string) => markAsRead(flowAPI, id),
      getNextPage: async (cursor: string) => {
        const nextNotificationsRes = await getNotifications(flowAPI, cursor);
        controllerConfig.setProps({
          notificationsRes: nextNotificationsRes,
        });
      },
      fitToContentHeight: true,
    });
  };

  return {
    async pageReady() {
      if (
        flowAPI.experiments.enabled(
          'specs.ping.MANotifications.useMAWidgetPluginService',
        )
      ) {
        const isRendered = widgetPluginService.getIsRendered();
        controllerConfig.setProps({ useLoadable: true });

        if (isRendered) {
          await initialize();
        }
      } else {
        await initialize();
      }
    },
    exports: () => {
      return createWidgetPluginExports(widgetPluginService, initialize);
    },
  };
};

export default createController;
